import { generateAutoDescription } from './forumDescriptionGenerator';
import { getForumMetaDescription, getForumKeywords } from './forumSeo';

// Forum açıklamaları ve SEO metinleri
export const forumDescriptions: Record<string, string> = {
  // Teknoloji Forumları
  'technopat': 'Türkiye\'nin en büyük teknoloji topluluğu. Donanım, yazılım, oyun ve teknoloji haberlerinde uzman görüşleri. 500.000+ üye ile aktif tartışmalar.',
  'donanimhaber': 'Donanım ve teknoloji dünyasının nabzını tutan forum. PC toplama, donanım testleri ve teknoloji incelemeleri. Uzman kullanıcılardan profesyonel tavsiyeler.',
  'chip': 'Bilgisayar ve teknoloji meraklılarının buluşma noktası. Donanım sorunları, yazılım önerileri ve teknoloji tartışmaları için ideal platform.',
  'ituforum': 'İTÜ öğrenci ve mezunlarının akademik ve teknoloji odaklı tartışma platformu. Mühendislik, bilim ve teknoloji konularında derinlemesine analizler.',
  'mobilhanem': 'Mobil teknoloji ve akıllı telefon dünyasının rehberi. Android, iOS, tablet ve mobil uygulama incelemeleri. Güncel mobil teknoloji haberleri.',
  
  // Oyun Forumları
  'oyunfor': 'Türk oyuncuların en büyük buluşma noktası. PC, konsol ve mobil oyun incelemeleri, rehberleri ve topluluk etkinlikleri.',
  'gameturk': 'Oyun dünyasının her türlü haberini ve incelemesini bulabileceğiniz kapsamlı platform. Oyuncu topluluğu ile interaktif deneyim.',
  'mmocenter': 'MMORPG ve online oyun tutkunlarının merkezi. Oyun rehberleri, guild organizasyonları ve oyuncu buluşmaları.',
  'lolturk': 'League of Legends Türkiye topluluğu. Strateji rehberleri, turnuva haberleri ve oyuncu eşleştirmeleri.',
  
  // Eğitim Forumları
  'uludagsozluk': 'Türkiye\'nin en eski ve köklü sözlük platformu. Gündem, kültür, sanat ve yaşam üzerine özgün yazılar ve tartışmalar.',
  'eksisozluk': 'Türkiye\'nin en popüler sözlük sitesi. Güncel olaylar, kültür, sanat ve yaşamın her alanından entry\'ler ve tartışmalar.',
  'itusozluk': 'İTÜ öğrenci ve mezunlarının akademik ve sosyal paylaşım platformu. Üniversite yaşamı, kariyer ve teknoloji odaklı içerikler.',
  
  // Spor Forumları
  'mackolik': 'Türkiye\'nin en büyük spor topluluğu. Futbol, basketbol ve diğer spor dallarında canlı tartışmalar ve analizler.',
  'sporx': 'Spor tutkunlarının buluşma noktası. Maç analizleri, transfer haberleri ve spor yorumları. Tüm spor dallarından güncel haberler.',
  'fanatik': 'Futbol ve spor dünyasının nabzını tutan platform. Takım taraftarları arası tartışmalar ve spor haberleri.',
  
  // Otomotiv Forumları
  'garageturk': 'Otomobil tutkunlarının teknik bilgi paylaşım merkezi. Araba bakımı, modifikasyon ve otomotiv teknolojileri.',
  'otomobilim': 'Otomobil sahipleri için kapsamlı bilgi platformu. Araç incelemeleri, bakım tavsiyeleri ve satış-alım rehberleri.',
  'arabam': 'Türkiye\'nin en büyük otomobil topluluğu. İkinci el araç değerlendirmeleri, teknik destek ve otomotiv haberleri.',
  
  // Sağlık ve Yaşam Forumları
  'saglikforumu': 'Sağlık konularında güvenilir bilgi paylaşım platformu. Uzman doktor görüşleri ve sağlık tavsiyeleri.',
  'anneyiz': 'Anne ve bebek sağlığı odaklı topluluk. Hamilelik, doğum ve çocuk bakımı konularında deneyim paylaşımları.',
  'diyet': 'Sağlıklı yaşam ve beslenme rehberi. Diyet programları, fitness tavsiyeleri ve kilo verme deneyimleri.',
  
  // Hobi ve İlgi Alanları
  'fotografya': 'Fotoğraf sanatı ve teknik bilgi paylaşım merkezi. Ekipman incelemeleri, çekim teknikleri ve fotoğraf yarışmaları.',
  'muzikforumu': 'Müzik tutkunlarının buluşma noktası. Enstrüman eğitimi, müzik teorisi ve sanatçı tartışmaları.',
  'kitapkurdu': 'Kitap severler için kapsamlı platform. Kitap incelemeleri, yazar röportajları ve okuma önerileri.',
  
  // Finans ve Ekonomi
  'yatirimforum': 'Yatırım ve finans dünyasının rehberi. Borsa analizleri, ekonomi yorumları ve yatırım stratejileri.',
  'dolarforum': 'Döviz ve ekonomi takipçilerinin platformu. Güncel kurlar, ekonomik analizler ve yatırım tavsiyeleri.',
  
  // Ev ve Yaşam
  'evdekorasyonu': 'Ev dekorasyonu ve tasarım ilhamı merkezi. DIY projeleri, dekorasyon fikirleri ve ev düzenleme tavsiyeleri.',
  'bahcecilik': 'Bahçıvanlık ve bitki bakımı rehberi. Sebze yetiştirme, çiçek bakımı ve peyzaj tasarımı konularında uzman tavsiyeleri.',
  
  // Teknoloji Alt Kategorileri
  'webmaster': 'Web tasarım ve geliştirme topluluğu. HTML, CSS, JavaScript ve web teknolojileri üzerine teknik tartışmalar.',
  'programlama': 'Yazılım geliştiricilerin bilgi paylaşım platformu. Programlama dilleri, algoritma ve yazılım geliştirme süreçleri.',
  'linux': 'Linux ve açık kaynak yazılım topluluğu. Sistem yönetimi, dağıtım incelemeleri ve teknik destek.',
  
  // Sanat ve Kültür
  'sanatforumu': 'Sanat ve kültür dünyasının tartışma platformu. Resim, heykel, edebiyat ve sahne sanatları üzerine derinlemesine analizler.',
  'sinema': 'Film tutkunlarının buluşma noktası. Film incelemeleri, yönetmen analizleri ve sinema haberleri.',
  
  // Seyahat ve Turizm
  'gezginler': 'Seyahat tutkunlarının deneyim paylaşım merkezi. Gezi rehberleri, otel tavsiyeleri ve seyahat ipuçları.',
  'tatilbudur': 'Tatil planlama ve seyahat önerileri platformu. Destinasyon rehberleri, konaklama tavsiyeleri ve seyahat deneyimleri.',
  
  // İş ve Kariyer
  'kariyernet': 'Kariyer gelişimi ve iş arama platformu. CV hazırlama, mülakat teknikleri ve sektörel kariyer tavsiyeleri.',
  'isarayan': 'İş arayanlar ve işverenler için buluşma noktası. İş ilanları, kariyer fırsatları ve mesleki gelişim.',
  
  // Alışveriş ve Tüketici
  'shiftdelete': 'Teknoloji haberleri ve ürün incelemeleri. Gadget testleri, yazılım analizleri ve teknoloji trendleri.',
  'cimri': 'Akıllı alışveriş ve fiyat karşılaştırma topluluğu. Ürün incelemeleri, indirim fırsatları ve tüketici deneyimleri.',
  
  // Eğlence ve Sosyal
  'caps': 'Mizah ve eğlence içerikleri platformu. Komik görseller, viral içerikler ve sosyal medya trendleri.',
  'uykusuzlar': 'Gece kuşlarının sosyal buluşma platformu. Sohbet, oyun ve eğlence odaklı topluluk aktiviteleri.',
  
  // Bölgesel ve Yerel
  'istanbulforumu': 'İstanbul yaşamı ve şehir rehberi. Mekan önerileri, etkinlik duyuruları ve şehir yaşamı deneyimleri.',
  'ankaraforumu': 'Ankara\'da yaşayanlar için yerel bilgi paylaşım platformu. Şehir haberleri, etkinlikler ve sosyal aktiviteler.',
  'izmirforumu': 'İzmir ve Ege bölgesi yaşam rehberi. Yerel haberler, kültürel etkinlikler ve şehir yaşamı.',
  
  // Özel İlgi Alanları
  'astronomi': 'Astronomi ve uzay bilimleri meraklılarının platformu. Gözlem teknikleri, uzay haberleri ve bilimsel tartışmalar.',
  'tarih': 'Tarih meraklılarının bilgi paylaşım merkezi. Tarihsel olaylar, arkeoloji haberleri ve tarih araştırmaları.',
  'felsefe': 'Felsefe ve düşünce dünyası tartışma platformu. Felsefi akımlar, düşünür analizleri ve entelektüel sohbetler.',
  
  // Teknoloji Markaları
  'apple': 'Apple ürünleri kullanıcılarının buluşma noktası. iPhone, iPad, Mac incelemeleri ve kullanım ipuçları.',
  'samsung': 'Samsung teknoloji ürünleri topluluğu. Akıllı telefon, tablet ve elektronik cihaz incelemeleri.',
  'xiaomi': 'Xiaomi kullanıcıları ve teknoloji tutkunlarının platformu. Ürün incelemeleri, ROM geliştirme ve teknik destek.',
  
  // Spor Alt Kategorileri
  'besiktas': 'Beşiktaş taraftarlarının resmi olmayan buluşma platformu. Maç analizleri, transfer haberleri ve taraftar etkinlikleri.',
  'galatasaray': 'Galatasaray topluluğunun tartışma merkezi. Takım haberleri, oyuncu analizleri ve sarı-kırmızı tutkusu.',
  'fenerbahce': 'Fenerbahçe taraftarlarının sosyal platformu. Maç yorumları, takım haberleri ve taraftar organizasyonları.',
  
  // Eğitim Alt Kategorileri
  'lgs': 'LGS sınavına hazırlanan öğrenciler için destek platformu. Soru çözümleri, deneme sınavları ve motivasyon desteği.',
  'yks': 'YKS ve üniversite sınavları rehberi. Ders programları, soru bankası önerileri ve sınav stratejileri.',
  'kpss': 'KPSS ve kamu personel sınavları hazırlık merkezi. Ders notları, soru çözümleri ve başarı hikayeleri.',
  
  // Sağlık Alt Kategorileri
  'diabet': 'Diyabet hastaları ve yakınları için bilgi paylaşım platformu. Beslenme tavsiyeleri, tedavi deneyimleri ve uzman görüşleri.',
  'kalp': 'Kalp sağlığı ve kardiyovasküler hastalıklar bilgi merkezi. Önleme yöntemleri, tedavi seçenekleri ve yaşam tarzı önerileri.',
  
  // Hobi Alt Kategorileri
  'balik': 'Balık tutma ve su ürünleri hobi platformu. Avlama teknikleri, ekipman incelemeleri ve balık türleri rehberi.',
  'kamp': 'Kamp ve doğa sporları tutkunlarının buluşma noktası. Kamp alanları, ekipman tavsiyeleri ve doğa deneyimleri.',
  'bisiklet': 'Bisiklet sporları ve bisiklet tutkunları topluluğu. Rota önerileri, bisiklet bakımı ve cycling etkinlikleri.'
};

// Kategori bazlı varsayılan açıklamalar
export const categoryDefaultDescriptions: Record<string, string> = {
  'Teknoloji': 'Teknoloji dünyasının nabzını tutan topluluk. Donanım, yazılım ve teknoloji haberleri ile uzman görüşleri.',
  'Oyun': 'Oyun tutkunlarının buluşma noktası. Oyun incelemeleri, rehberleri ve topluluk etkinlikleri.',
  'Eğitim': 'Eğitim ve akademik paylaşım platformu. Ders materyalleri, sınav hazırlığı ve öğrenci deneyimleri.',
  'Spor': 'Spor tutkunlarının tartışma merkezi. Maç analizleri, takım haberleri ve spor yorumları.',
  'Otomotiv': 'Otomobil ve motorsport meraklılarının teknik bilgi paylaşım platformu.',
  'Sağlık': 'Sağlık konularında güvenilir bilgi paylaşım merkezi. Uzman tavsiyeleri ve deneyim paylaşımları.',
  'Hobi': 'Hobi ve ilgi alanları topluluğu. Yaratıcı projeler, teknik bilgiler ve deneyim paylaşımları.',
  'Finans': 'Finans ve yatırım dünyasının rehberi. Ekonomi analizleri ve yatırım stratejileri.',
  'Yaşam': 'Günlük yaşam ve lifestyle konularında pratik bilgiler ve deneyim paylaşımları.',
  'Sanat': 'Sanat ve kültür dünyasının tartışma platformu. Yaratıcı içerikler ve sanatsal analizler.',
  'Seyahat': 'Seyahat tutkunlarının deneyim paylaşım merkezi. Gezi rehberleri ve seyahat tavsiyeleri.',
  'Alışveriş': 'Akıllı alışveriş ve tüketici deneyimleri platformu. Ürün incelemeleri ve fiyat karşılaştırmaları.',
  'Sosyal': 'Sosyal paylaşım ve topluluk etkileşim platformu. Sohbet, tartışma ve sosyal aktiviteler.',
  'Bölgesel': 'Yerel topluluk ve bölgesel bilgi paylaşım merkezi. Şehir haberleri ve yerel etkinlikler.'
};

// Forum açıklaması oluşturma (liste/detay fallback — admin güncelleme ile aynı motor)
export function generateForumDescription(
  forumId: string,
  forumName: string,
  category: string,
  membersCount: number,
  postsCount: number,
  topicsCount = 0
): string {
  const customDescription = forumDescriptions[forumId.toLowerCase()];
  if (customDescription) return customDescription;

  return generateAutoDescription({
    forum_id: forumId,
    name: forumName,
    category,
    members_count: membersCount,
    posts_count: postsCount,
    topics_count: topicsCount,
  });
}

// SEO meta açıklaması oluşturma (marka odaklı — forumSeo ile uyumlu)
export function generateSEODescription(
  forumName: string,
  category: string,
  membersCount: number,
  topicsCount: number,
  postsCount = 0
): string {
  return getForumMetaDescription({
    forum_id: forumName.toLowerCase().replace(/\s+/g, '-'),
    name: forumName,
    category,
    members_count: membersCount,
    topics_count: topicsCount,
    posts_count: postsCount,
  });
}

// Forum anahtar kelimeleri oluşturma (marka odaklı)
export function generateKeywords(forumName: string, category: string, forumId?: string): string {
  return getForumKeywords({
    forum_id: forumId || forumName.toLowerCase().replace(/\s+/g, '-'),
    name: forumName,
    category,
    members_count: 0,
    topics_count: 0,
    posts_count: 0,
  });
}